import { Routes } from '@angular/router';
import { ClienteComponent } from './cliente/cliente.component';
import { AvisoPrivacidadComponent } from './components/aviso-privacidad/aviso-privacidad.component';
import { TerminosCondicionesComponent } from './components/terminos-condiciones/terminos-condiciones.component';
import { ReferidosComponent } from './components/referidos/referidos.component';
import { PromoRenovacionComponent } from './components/promo-renovacion/promo-renovacion.component';
import { PromotorComponent } from './promotor/promotor.component';

export const routes: Routes = [
  { path: 'cliente', component: ClienteComponent },
  { path: 'promotor', component: PromotorComponent },
  { path: 'aviso-privacidad', component: AvisoPrivacidadComponent },
  { path: 'terminos-condiciones', component: TerminosCondicionesComponent },
  { path: 'referidos', component: ReferidosComponent },
  { path: 'terms/referidos', component: ReferidosComponent },
  {path: 'tyc/promo-renovacion', component: PromoRenovacionComponent},
  {path: 'promo-renovacion', component: PromoRenovacionComponent},
  { path: '', redirectTo: '/cliente', pathMatch: 'full' }

];
